import { Injectable } from '@angular/core';
import { environment } from "../environments/environment";
import { Http, Headers, Response } from "@angular/http";
import { Observable } from "rxjs/Observable"
import { AuthHttp } from 'angular2-jwt';

import "rxjs/add/operator/map";

@Injectable()
export class DashboardApiService {
  constructor(private authHttp : AuthHttp) { }
  
  GetDashboardYearList(){
    return this.authHttp.get(environment.apiEndPoint + '/Dashboard/GetYearList')
    .map((response : Response) => response.json())
  }
  
  GetDashboardDealerData(year){
    return this.authHttp.get(environment.apiEndPoint + '/Dashboard/Dealer/' + year)
    .map((response : Response) => response.json())
  }

  IsDashboardDealerShow(){
    return this.authHttp.get(environment.apiEndPoint + '/Dashboard/Dealer/IsDashboard')
    .map((response : Response) => response.json())
  }
  
  GetDashboardMainDealerData(year, quartal){
    return this.authHttp.get(environment.apiEndPoint + '/Dashboard/MainDealer/' + year + '/' + quartal)
    .map((response : Response) => response.json())
  }
  
  GetDashboardMaindealerDetailData(year, quartal){
    return this.authHttp.get(environment.apiEndPoint + '/Dashboard/MainDealer/Detail/' + year + '/' + quartal)
    .map((response : Response) => response.json())
  }
  
  GetDashboardHeadOfficeData(mainDealerId, year, quartal){
    return this.authHttp.get(environment.apiEndPoint + '/Dashboard/HO/' + mainDealerId + '/' + year + '/' + quartal)
    .map((response : Response) => response.json())
  }
  
  GetDashboardHeadOfficeDetailData(mainDealerId, year, quartal){
    return this.authHttp.get(environment.apiEndPoint + '/Dashboard/HO/Detail/' + mainDealerId + '/' + year + '/' + quartal)
    .map((response : Response) => response.json())
  }
}


// WEBPACK FOOTER //
// /Users/muhammadfiqihfirdiansyah/Documents/Muhammad Fiqih Firdiansyah/Project/Angular/BODES/BODES.Web.UI.Angular4/src/data/DashboardApi.service.ts